const certificationsArray = [
  {
    id: "1",
    certificationName:
      "BSc (Hons) in Information Technology specialized in Software Engineering (Second class - Upper)",
    certificationThumbnail:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSsvGpcJiDeEH13RLRT1Mx9K1L4czzguR_Kar5Qy08&s",
    certificationDescription:
      "I am proud to say that I graduated from Sri Lanka Institute of Information Technology (SLIIT) with a Bachelor of Science (Honours) degree in Information Technology, specializing in Software Engineering. I achieved a second class upper division, which reflects my dedication and hard work throughout my academic career. I am excited to bring the skills and knowledge I gained at SLIIT to my future endeavors.",
    certificationURL: "https://www.google.com",
  },
  {
    id: "2",
    certificationName:
      "Bachelors in Information Communication Technology (Hons) specialized in Games and Animation Development",
    certificationThumbnail:
      "https://i.ytimg.com/vi/vjDPf4NFQb4/maxresdefault.jpg",
    certificationDescription:
      "I am currently enrolled in the Bachelor's program in Information Communication Technology (Hons) at the esteemed University of Kelaniya, with a specialization in Games and Animation Development. This comprehensive program has provided me with a deep understanding of the theory and practical applications of ICT, with a particular focus on game design and animation development. Through engaging lectures, practical workshops, and cutting-edge coursework, I am gaining the knowledge and skills necessary to excel in the ever-evolving field of games and animation.",
    certificationURL: "https://www.google.com",
  },
  {
    id: "3",
    certificationName:
      "Diploma in Information Technology at ESOFT Metro Campus",
    certificationThumbnail:
      "https://upload.wikimedia.org/wikipedia/commons/8/83/ESOFT_Logo_1000_x_450_RGB.jpg",
    certificationDescription:
      "I successfully completed a comprehensive Diploma in Information Technology program at ESOFT Metro Campus, which equipped me with a strong foundation in various aspects of IT. The program covered a wide range of subjects, including computer programming, database management, network administration, and web development. Through hands-on practical assignments and rigorous coursework, I gained practical skills and in-depth knowledge in the field of information technology.",
    certificationURL: "https://www.google.com",
  },
  {
    id: "4",
    certificationName: "Certificate in IT (BCS - British Computer Society)",
    certificationThumbnail:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQKLslbE76gaKH9Ag5CdxY32vByV_z1cG7FunmjzOsa&s",
    certificationDescription:
      "I completed a Certificate in Information Technology program through the British Computer Society (BCS), which provided me with a solid foundation in the field of IT. The program covered a wide range of topics, including computer hardware and software, programming, web development, and database management. Through my studies, I gained valuable skills and knowledge that have helped me to succeed in my career. The certificate program also allowed me to become a member of the BCS, which has provided me with access to a community of IT professionals and ongoing professional development opportunities.",
    certificationURL: "https://www.google.com",
  },
];

module.exports = {
  certificationsArray,
};
